import React, { Suspense, lazy } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import LayoutContainer from "./Helper/LayerContainer";
import './App.scss';
import { CircularProgress } from "@mui/material";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';

// Lazy load the pages
const Home = lazy(() => import("./Pages/Home/Home"));
const AboutUs = lazy(() => import("./Pages/AboutUs/AboutUs"));
const FindTour = lazy(() => import("./Pages/FindTour/FindTour"));
const ContactInfo = lazy(() => import("./Pages/ContactInfo/ContactInfo"));
const Tours = lazy(() => import("./Pages/Tours/Tours"));
const TourDetail = lazy(() => import("./Pages/TourDetail/TourDetail"));
const Reviews = lazy(() => import("./Pages/Reviews/Reviews"));
const AboutMeDetails = lazy(() => import("./Pages/AboutMeDetails/AboutMeDetails"));
const ContactUs = lazy(() => import("./Pages/ContactUs/ContactUs"));
const GuideProfile = lazy(() => import("./Pages/GuideProfile/GuideProfile"));

function App() {
  return (
    <BrowserRouter>
      <div className="app-container">
        <Suspense
          fallback={
            <div style={loadingStyle}>
              <CircularProgress color="primary" />
            </div>
          }
        >
          <Routes>
            <Route path="/" element={<LayoutContainer><Home/><AboutUs/><FindTour/><GuideProfile/><ContactInfo/></LayoutContainer>} />
            <Route path="/tours" element={<LayoutContainer isWhite={true}><Tours/></LayoutContainer>} />
            <Route path="/tour-detail/:id" element={<LayoutContainer isWhite={true}><TourDetail/></LayoutContainer>} />
            <Route path="/reviews" element={<LayoutContainer isWhite={true}><Reviews/></LayoutContainer>} />
            <Route path="/about" element={<LayoutContainer isWhite={true}><AboutMeDetails/></LayoutContainer>} />
            <Route path="/contact" element={<LayoutContainer isWhite={true}><ContactUs/></LayoutContainer>} />
          </Routes>
        </Suspense>

        {/* WhatsApp Button */}
        <a
  href="https://wa.me/212697662923"
  className="whatsapp-icon"
  target="_blank"
  rel="noopener noreferrer"
>
  <FontAwesomeIcon icon={faWhatsapp} />
</a>

      </div>
    </BrowserRouter>
  );
}

// Styles for loading spinner
const loadingStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100vh',
};

export default App;
